import React, { useState, useLayoutEffect, useRef, useCallback } from "react";
import { createSafeResizeHandler, withRAF } from "../../utils/resizeObserverUtils";

export const useResumePreviewSize = () => {
    const [resumePreviewSize, setResumePreviewSize] = useState([0, 0, '']);
    const lastSizeRef = useRef({ width: 0, height: 0 });
    const updateResumeSize = useCallback(() => {
        const resumeDiv = document.getElementById('preview-resume');
        if (resumeDiv != null) {
            const width = resumeDiv.clientWidth;
            const height = resumeDiv.clientHeight;
            
            // Only update if size actually changed to prevent unnecessary re-renders
            if (width !== lastSizeRef.current.width || height !== lastSizeRef.current.height) {
                lastSizeRef.current = { width, height };
                const scale = getScale(width, height);
                setResumePreviewSize([width, height, scale]);
            }
        }
    }, []);

    const getScale = (w, h) => {
        return w / 641;
    }
    // Wrap updateResumeSize with RAF to prevent ResizeObserver loops
    const safeUpdateResumeSize = withRAF(updateResumeSize);

    useLayoutEffect(() => {
        // Use safe resize handler to prevent infinite loops
        const cleanup = createSafeResizeHandler(safeUpdateResumeSize, {
            debounceMs: 16, // ~60fps
            maxWaitMs: 100
        });
        
        // Initial update
        safeUpdateResumeSize();
        
        return cleanup;
    }, [safeUpdateResumeSize]);
    
    return [resumePreviewSize[0], resumePreviewSize[1], resumePreviewSize[2]];
}